import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";

import { Subscription } from "rxjs";
import { LayoutService } from "../services/layout.service";
import { FooterComponent } from "./footer/footer.component";

@Component({
  selector: "dms-admin-panel",
  templateUrl: "./admin-panel.component.html",
  styleUrls: ["./admin-panel.component.scss"],
})
export class AdminPanelComponent implements OnInit {
  entryComponent = FooterComponent;
  pageTitle: any;
  subscription: Subscription;

  constructor(
    private location: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private layoutService: LayoutService,
    private cookieService: CookieService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let child = this.activatedRoute.firstChild;
        this.pageTitle = child.snapshot.data["breadcrumb"];

        // for eg: utilities
        if (!this.pageTitle) {
          this.pageTitle = this.layoutService.pageTitle;
        }
      }
    });
  }

  ngOnInit() {}

  logout(): void {
    this.cookieService.deleteAll();
    this.router.navigate(["/login"]);
  }

  goBack(): void {
    this.location.back();
  }
}
